import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from "../../../../Common";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi, { x } from "@hapi/joi";
import { LentLabourReportSchemaObject } from "../LentContractDetailsReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from "./createPdf";
import "../../../Common/Table/table.css";
import xlsx from "json-as-xlsx";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Box from "@material-ui/core/Box";
import _ from "lodash";
import TablePagination from '@material-ui/core/TablePagination';
import moment from 'moment';
import MessageModal from '../../../../UI/Modal/MessageModal';

const screenCode = "TIPPINGDETAILSREPORT";

export function TippingDetailsReport(props) {
  const componentRef = useRef();
  const [divisions, setDivisions] = useState([]);
  const [groups, setGroups] = useState([]);
  const [estates, setEstates] = useState([]);
  const [multipleEstates, setMultipleEstates] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [lentLabourDetails, setLentLabourDetails] = useState({
    groupID: "0",
    estateID: "0",
    divisionID: "0",
    fromDate: new Date().toISOString().split('T')[0],
    toDate: new Date().toISOString().split('T')[0]
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupID: "0",
    estateID: "0",
    division: "0",
    fromDate: "",
    toDate: "",
  });

  const [errors, setErrors] = useState({});

  const [permissionList, setPermissions] = useState({
    isAddEditEnabled: false,
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });

  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: ""
  });

  const newCol = ["Session 1", "Session 2", "Session 3"]
  const [data, setdata] = useState([]);
  const [totalValues, setTotalValues] = useState({
    total1st: "0",
    total2nd: "0",
    total3rd: "0",
    total4th: "0",
    alltotal: "0",
  });
  const [summeryData, setSummeryData] = useState([]);


  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const schema = Joi.object(LentLabourReportSchemaObject).options({
    allowUnknown: true,
  });
  const options = {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
  const [csvHeaders, setCsvHeaders] = useState([
    { label: "Registration Number", value: "date" },
    { label: "Employee Name", value: "name" },
    { label: "Date", value: "subBlock" },
    { label: "1st Wt", value: "blockOwnerName" },
    { label: "2nd Wt", value: "supplierRegNo" },
    { label: "3rd Wt", value: "workerName" },
    { label: "4th Wt", value: "qty" },
    { label: "Operator", value: "userName" },
  ]);

  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    trackPromise(getPermissions(), getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getEstatesForDropdown());
  }, [lentLabourDetails.groupID]);

  useEffect(() => {
    trackPromise(getDivisionsForDropDown());
  }, [lentLabourDetails.estateID]);

  useEffect(() => {
    setdata([]);
    setReportData([]);
  }, [lentLabourDetails.groupID, lentLabourDetails.estateID, lentLabourDetails.divisionID]);

  useEffect(() => { }, [reportData]);

  function handleGroupChange(target) {
    validateInputs(target);

    const currentDate = new Date().toISOString().split('T')[0];

    setLentLabourDetails({
      ...lentLabourDetails,
      groupID: target.value,
      estateID: "0",
      divisionID: "0",
      fromDate: currentDate,
      toDate: currentDate
    });
  }

  function handleEstateChange(target) {
    validateInputs(target);

    const currentDate = new Date().toISOString().split('T')[0];

    setLentLabourDetails({
      ...lentLabourDetails,
      estateID: target.value,
      divisionID: "0",
      fromDate: currentDate,
      toDate: currentDate
    });
  }

  function handleDivisionChange(target) {
    validateInputs(target);

    setLentLabourDetails({
      ...lentLabourDetails,
      divisionID: target.value,
    });
  }

  function modalDismissHandler() {
    setMessageModel({
      ...messageModel,
      hidden: true
    });
  }

  function handleFromDateChange(target) {
    validateInputs(target);

    setLentLabourDetails({
      ...lentLabourDetails,
      fromDate: target.value,
    });
  }

  function handleToDateChange(target) {
    validateInputs(target);

    setLentLabourDetails({
      ...lentLabourDetails,
      toDate: target.value,
    });
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(
      target,
      LentLabourReportSchemaObject
    );
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWTIPPINGDETAILSREPORT"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }
    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );

    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });
    var token = tokenService.getUserDetailsFromTokenV2();

    if (token.operationEntities.length > 0) {

      var estateArray = [];
      for (let item of Object.entries(token.operationEntities)) {
        estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
      }

      setMultipleEstates(estateArray)

      setLentLabourDetails({
        ...lentLabourDetails,
        groupID: token.groupID
      });

    } else {
      setLentLabourDetails({
        ...lentLabourDetails,
        groupID: token.groupID,
        estateID: token.operationEntityID,
      });
    }

    setLentLabourDetails({
      ...lentLabourDetails,
      groupID: token.groupID,
      estateID: token.operationEntityID,
    });
    trackPromise(getGroupsForDropdown());
  }

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getEstatesForDropdown() {
    const data = await services.getEstatesByGroupID(
      lentLabourDetails.groupID
    );
    setEstates(data);
  }

  async function getDivisionsForDropDown() {
    const data = await services.getDivisionByEstateID(
      lentLabourDetails.estateID
    );
    setDivisions(data);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  async function handleSearch(e) {
    e.preventDefault();

    const errorMessages = validate(schema, lentLabourDetails);

    if (errorMessages) {
      setErrors(errorMessages);
      return;
    }

    setErrors({});

    getSelectedDropdownValuesForReport(lentLabourDetails);
    var reportData = await services.getLentContractDetailsReportData(lentLabourDetails);
    if (reportData && reportData.length > 0) {
      formatResult(reportData);
      setReportData(reportData);
      destroyDataTable();
    } else {
      setdata([]);
      setReportData([]);
      setSummeryData([]);

      setMessageModel({
        hidden: false,
        type: "Warning",
        disciption: "No records found for the selected criteria."
      });

      setTimeout(() => {
        setMessageModel((prevModel) => ({
          ...prevModel,
          hidden: true
        }));
      }, 4000);
    }
  }

  function formatResult(data) {
    var result = [];
    var totalOfAllrecords = 0;
    let totalOfUnits = 0
    var names = [...newCol];
    var dates = [];
    var csvHeaders = [
      { label: "Registration Number", value: "registrationNumber" },
      { label: "Employee Name", value: "firstName" },
      { label: "Date", value: "date" },
    ];
    newCol.forEach(session => {
      csvHeaders.push({ label: session, value: session });
    });

    data.forEach(x => {
      var sessionName = x.sessionName.replace(/^Session(\d+)$/, 'Session $1');
      if (result.length === 0) {
        result.push({
          [sessionName]: checkUndifind(x.totalAmount),
          employeeID: parseInt(x.employeeID),
          registrationNumber: x.registrationNumber,
          firstName: x.name,
          total: checkUndifind(x.totalAmount),
          [sessionName + ' ReadTime']: x.date,
          date: moment(x.date).format("YYYY-MM-DD")
        });
        if (!names.includes(sessionName)) {
          names.push(sessionName);
          csvHeaders.push({ label: sessionName, value: sessionName });
        }
        dates.push(x.date);
        totalOfAllrecords = totalOfAllrecords + parseFloat(x.totalAmount);
        totalOfUnits = totalOfUnits + x.numberOfUnits
      } else {
        totalOfAllrecords = totalOfAllrecords + parseFloat(x.totalAmount);
        totalOfUnits = totalOfUnits + x.numberOfUnits
        var duplicate = result.find(y => parseInt(y.employeeID) == parseInt(x.employeeID));

        var duplicateName = names.find(y => y === sessionName);
        var duplicateDates = dates.find(z => z === x.date)
        if (!duplicateName) {
          names.push(sessionName);
          csvHeaders.push({ label: sessionName, value: sessionName });
        }
        if (duplicate && duplicateDates) {
          duplicate[sessionName] = checkUndifind(duplicate[sessionName]) + checkUndifind(x.totalAmount);
          duplicate.registrationNumber = x.registrationNumber;
          duplicate.firstName = x.name;
          duplicate[sessionName + ' ReadTime'] = x.date;
          duplicate.total = checkUndifind(duplicate.total) + checkUndifind(x.totalAmount);
        }
        else {
          result.push({
            [sessionName]: checkUndifind(x.totalAmount),
            employeeID: parseInt(x.employeeID),
            registrationNumber: x.registrationNumber,
            firstName: x.name,
            total: checkUndifind(x.totalAmount),
            [sessionName + ' ReadTime']: x.date,
            date: moment(x.date).format("YYYY-MM-DD")
          });
        }
      }
    });
    csvHeaders.push({ label: "Total(Kg)", value: "total" });
    names.sort((a, b) => a > b ? 1 : -1);

    var result2 = []
    result.forEach(x => {
      names.forEach(y => {
        if (x[y]) {
          result2.push({
            property: y,
            value: checkUndifind(x[y])
          });
        }
      });
    });

    const result3 = result2.reduce((obj, el) => {
      obj[el.property] = (obj[el.property] || 0) + el.value;
      return obj;
    }, {});

    let totalAmount = 0;
    result.forEach(tt => {
      totalAmount += tt.total
    });

    setTotalValues({
      ...totalValues,
      alltotal: totalAmount,
    });

    setCsvHeaders(csvHeaders);
    setdata(result);

    var resultqqqq = Object.entries(result3);

    var temlArry = [];

    for (const key in resultqqqq) {
      temlArry.push({
        name: resultqqqq[key][0],
        value: resultqqqq[key][1]
      })
    }

    temlArry.sort((a, b) => a.name > b.name ? 1 : -1);
    setSummeryData(temlArry);
  }

  function checkUndifind(value) {
    if (value === undefined) {
      return 0;
    }
    else {
      return value;
    }
  }


  function createFile() {
    var settings = {
      sheetName: "Tipping Details Report",
      fileName: "Tipping Details Report",
      writeOptions: {},
    };

    var copyOfCsv = _.cloneDeep(data);

    let sessionTotals = {};
    let overallTotal = 0;

    copyOfCsv.forEach(row => {
      if (row) {
        Object.keys(row).forEach(key => {
          if (key.startsWith('Session') && !key.endsWith('ReadTime')) {
            let value = row[key] || 0;
            if (!sessionTotals[key]) {
              sessionTotals[key] = 0;
            }
            sessionTotals[key] += value;
          }
        });
      }
      overallTotal += row.total;
    });

    let totalRow = { registrationNumber: "Total" };

    newCol.forEach(session => {
      totalRow[session] = sessionTotals[session] || 0;
    });

    Object.keys(sessionTotals).forEach(session => {
      if (!(session in totalRow)) {
        totalRow[session] = sessionTotals[session];
      }
    });

    totalRow['total'] = overallTotal;
    var newRow1 = {
      registrationNumber: "Group :" + groups[lentLabourDetails.groupID],
      firstName: "Operation Entity: " + estates[lentLabourDetails.estateID],
      date: "Collection Point : " + divisions[lentLabourDetails.divisionID]
    }
    var newRow2 = {
      registrationNumber: "From Date : " + lentLabourDetails.fromDate,
      firstName: "To Date : " + lentLabourDetails.toDate,
    }
    copyOfCsv.push(totalRow, {}, newRow1, newRow2)
    xlsx(csvHeaders, copyOfCsv, settings, true);
  }

  function destroyDataTable() {
    $("#example3").DataTable().destroy();
  }

  function onCancelClick() {
    clearState();
  }

  function clearState() {
    setLentLabourDetails({
      ...lentLabourDetails,
      divisionID: "0",
      fromDate: new Date().toISOString().split('T')[0],
      toDate: new Date().toISOString().split('T')[0]
    });
    setdata([]);
    setReportData([]);
    setErrors({});
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      group: groups[searchForm.groupID],
      estate: estates[searchForm.estateID],
      division: divisions[searchForm.divisionID],
      fromDate: searchForm.fromDate,
      toDate: searchForm.toDate,
    });
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <PageHeader
              title="Tipping Details Report"
              isButtonEnable={permissionList.isAddEditEnabled}
            />
            <div className="card-body">
              <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                <div className="form-group row">
                  <div className="col-md-3">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="groupID"
                      id="groupID"
                      name="groupID"
                      value={lentLabourDetails.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>
                  <div className="col-md-3">
                    <InputLabel shrink id="estateID">
                      Operation Entity *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="estateID"
                      id="estateID"
                      name="estateID"
                      value={lentLabourDetails.estateID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleEstateChange(e.target)}
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                      {generateDropDownMenu(
                        Object.fromEntries(
                          Object.entries(estates).filter(([key, value]) => {
                            if (key === "0" || !value) return false;
                            if (!multipleEstates || Object.keys(multipleEstates).length === 0) {
                              return true;
                            }
                            return Object.values(multipleEstates).includes(value);
                          })
                        )
                      )}
                    </Select>
                    {errors["estateID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["estateID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md-3">
                    <InputLabel shrink id="">
                      Collection Point*
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="divisionID"
                      id="divisionID"
                      name="divisionID"
                      value={lentLabourDetails.divisionID}
                      onChange={(e) => handleDivisionChange(e.target)}
                    >
                      <MenuItem value="0">--Select Collection Point--</MenuItem>
                      {generateDropDownMenu(divisions)}
                    </Select>
                    {errors["divisionID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["divisionID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md-3">
                    <InputLabel shrink id="fromDate">
                      From Date *
                    </InputLabel>
                    <TextField
                      fullWidth
                      id="fromDate"
                      name="fromDate"
                      type="date"
                      value={lentLabourDetails.fromDate}
                      maxDate={new Date()}
                      onChange={(e) => handleFromDateChange(e.target)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors["fromDate"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["fromDate"]}
                      </FormHelperText>
                    )}
                  </div>
                  <br />
                  <div className="col-md-3">
                    <InputLabel shrink id="toDate">
                      To Date *
                    </InputLabel>
                    <TextField
                      fullWidth
                      id="toDate"
                      name="toDate"
                      type="date"
                      value={lentLabourDetails.toDate}
                      maxDate={new Date()}
                      onChange={(e) => handleToDateChange(e.target)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors["toDate"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["toDate"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>
                <div className="card-footer">
                  <input
                    disabled={validate(schema, lentLabourDetails)}
                    type="button"
                    className="btn btn-primary"
                    value="Search"
                    onClick={(e) => trackPromise(handleSearch(e))}
                  />
                  <input
                    type="reset"
                    className="btn btn-warning pull-right"
                    value="Clear"
                    onClick={onCancelClick}
                  />
                </div>
              </form>
              {data.length != 0 ? (
                <div>
                  <div className="row">
                    <div className="col-md-12">
                      <div>
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <TableContainer component={Paper} style={{ border: "1px solid black", maxHeight: '700px', overflowY: 'auto' }}>
                            <Table style={{ borderCollapse: 'collapse', border: "1px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} size="small" aria-label="sticky table" stickyHeader>
                              <TableHead>
                                <TableRow style={{ border: "2px solid black" }}>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Registration Number</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Employee Name</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Date</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Session 1</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Session 2</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Session 3</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Total(Kg)</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody >
                                {data.slice(page * limit, page * limit + limit).map((row, i) => (
                                  <TableRow key={i} style={{ border: "2px solid black" }}>
                                    <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.registrationNumber}</TableCell>
                                    <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.firstName}</TableCell>
                                    <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black" }}>{row.date.split('T')[0]}</TableCell>
                                    {newCol.map((roww, index) => {
                                      const found = row[roww];
                                      return (
                                        <TableCell align="right" key={index} style={{ border: "2px solid black" }}>
                                          {found !== undefined ? parseFloat(found).toFixed(2) : ' - '}
                                        </TableCell>
                                      )
                                    })}
                                    <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}>{row.total.toFixed(2)}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                              <TableBody>
                                <TableRow style={{ border: "2px solid black" }}>
                                  <TableCell align="center" style={{ fontWeight: "bold" }} colSpan={3}>
                                    Total
                                  </TableCell>
                                  {newCol.map((item) => {
                                    const found = summeryData.find(x => x.name == item);
                                    if (found) {
                                      return (
                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align="right">
                                          {parseFloat(found.value).toFixed(2)}
                                        </TableCell>
                                      )
                                    }
                                    else {
                                      return (
                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align="right">
                                        </TableCell>
                                      )
                                    }
                                  })}
                                  <TableCell align="right" style={{ fontWeight: "bold" }} >
                                    {totalValues.alltotal == 0 ? '' : parseFloat(totalValues.alltotal).toLocaleString('en-US', options)}
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                            <TablePagination
                              component="div"
                              count={data.length}
                              onChangePage={handlePageChange}
                              onChangeRowsPerPage={handleLimitChange}
                              page={page}
                              rowsPerPage={limit}
                              rowsPerPageOptions={[5, 10, 25]}
                            />
                          </TableContainer>
                        </Box>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            {data.length != 0 ? (
              <div className="pt-2">
                <ReactToPrint
                  documentTitle={"Tipping Details Report"}
                  trigger={() => (
                    <input
                      type="button"
                      className="btn btn-primary pull-right ml-2"
                      value="PDF"
                    />
                  )}
                  content={() => componentRef.current}
                />
                <div hidden={true}>
                  <CreatePdf
                    ref={componentRef}
                    reportData={data}
                    searchData={selectedSearchValues}
                    summeryData={summeryData}
                    totalValues={totalValues}
                  />
                </div>{" "}
                <input
                  type="button"
                  className="btn btn-primary pull-right ml-2"
                  value="Excel"
                  onClick={createFile}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
        clicked={modalDismissHandler}
      />
    </Fragment>
  );
}